<script setup lang="ts">
import { computed } from 'vue';

import { NutsProduct } from '@/utils/product';
import { Admin } from '@/views/PDP.vue';

const props = defineProps<{
  bagSizes: Admin['bagSizes'];
  inventory: Admin['inventory'];
  productKey: NutsProduct['key'];
}>();

const hasAdminData = computed(
  () => props.bagSizes.length > 0 || Object.entries(props.inventory).length > 0,
);

const formattedBagSizes = props.bagSizes.join(', ');

const inventoryWarehouses = computed(() => Object.keys(Object.values(props.inventory)[0] ?? {}));
</script>

<template>
  <div v-if="hasAdminData" class="p-2.5 bg-lime-100" data-test="internal-notes">
    <p class="text-base font-semibold uppercase font-proxima-nova md:text-lg">
      Only visible to employees
    </p>
    <p
      v-if="bagSizes.length > 0"
      class="mt-1 text-base font-normal md:text-lg md:leading-6 font-proxima-nova"
      data-test="bag-sizes-viewer"
    >
      Bag Sizes: {{ formattedBagSizes }}
    </p>
    <table v-if="props.inventory" data-test="inventory-viewer" class="my-2 w-auto font-mono">
      <thead>
        <tr>
          <td />
          <th
            v-for="warehouse in inventoryWarehouses"
            :key="warehouse"
            class="px-2 text-right text-md"
            scope="col"
          >
            {{ warehouse }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(byWarehouse, sku) in props.inventory" :key="sku">
          <th class="px-2 text-left text-md" scope="row">{{ sku }}</th>
          <td
            v-for="(pieceCount, warehouse) in byWarehouse"
            :key="warehouse"
            class="px-2 text-right opacity-60 text-md"
          >
            {{ pieceCount || '' }}
          </td>
        </tr>
      </tbody>
    </table>
    <div class="mt-0.5" data-test="non-retail-inventory-viewer">
      <a
        :href="`https://nj.kw.nuts.com/items/${productKey}/piece_inventory?active_tab=${productKey}`"
        target="_blank"
      >
        <span class="underline text-cyan-800"> New Jersey Non-Retail Inventory </span>
      </a>
    </div>
  </div>
</template>

<style scoped>
p {
  @apply mb-0;
}
</style>
